import { render, staticRenderFns } from "./FSN_Banner.vue?vue&type=template&id=2bafb1b9&scoped=true&"
import script from "./FSN_Banner.vue?vue&type=script&lang=js&"
export * from "./FSN_Banner.vue?vue&type=script&lang=js&"
import style0 from "./FSN_Banner.vue?vue&type=style&index=0&id=2bafb1b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bafb1b9",
  null
  
)

export default component.exports